import { useEffect, useState } from "react";
import { Button, Container, Grid, Paper, Typography } from "@mui/material";
import SectionHeader from "../../../../components/merchants/SectionHeader";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import { faInfo, faInfoCircle, faTags } from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "../../../../components/sectionTitle";

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getAttributes } from "../../../../controllers/company/products/AttributesController";
import { deleteModifierGroup, getModifierGroups } from "../../../../controllers/company/products/ModifierGroupController";
import ModifierGroupsDataTable from "./dataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@mui/material";
import QUDProgress from "../../../../components/progress";

export default function ModifierGroups()
{
    const theme = useTheme();
    const [modifierGroups,setModifierGroups] = useState([]);
    const [isLoading,setIsLoading] = useState(false);

    useEffect(()=>{
        window.scrollTo(0,0);
        handleGetModifierGroups();
    },[]);

    const history = useHistory();

    const redirect = (route) => {
        history.push(route)
    }

    const handleGetModifierGroups = async () => {
        const response = await getModifierGroups();
        if(response.success === true)
        {
            setModifierGroups(response.data);
        }
    }

    const handleDeleteModifierGroup = async (id) => {
        setIsLoading(true);
        const response = await deleteModifierGroup(id);
        if(response.success === true)
        {
            //await handleGetAttributes();
            handleGetModifierGroups();
            //setAttributes(prevAttributes => prevAttributes.filter(attribute => attribute.id !== id));
        }
        setIsLoading(false);
    }


    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs returnTo='/products' crumbs={[{name:'Productos',link:'/products'},{name:'extras',link:'/products/modifiergroups'}]}/>
            <br/>
            <SectionTitle title='Grupo de Opciones' subtitle={'(Extras)'} />
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} lg={8}>
                    <Paper elevation={3} style={{padding:15,backgroundColor:'#ebf9ff'}}>
                        <Grid container alignContent={'center'} justifyContent={'center'}>
                            <Grid item xs={12} lg={2} textAlign={'center'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                <FontAwesomeIcon icon={faInfoCircle} size='2x' color={theme.palette.link.main}/>
                            </Grid>
                            <Grid item xs={12} lg={10}>
                                <Typography variant="h6" color={theme.palette.link.main} gutterBottom>
                                    ¿Qué son los Grupos de Opciones?
                                </Typography>
                                <Typography variant="body1" color={theme.palette.text.secondary} gutterBottom>
                                    Los Grupos de Opciones te permiten ofrecer complementos y personalizaciones para tus productos o servicios.
                                    Aquí creas las categorías para los extras o servicios adicionales que ofreces. Los clientes verán estos grupos en la página del producto.
                                    <br/>Ejemplos: "Personalización", "Garantías", "Accesorios", "Toppings".
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} lg={12} mt={5}>
                    <Button
                        mt={5}
                        variant='contained'
                        endIcon={<AddCircleIcon/>}
                        onClick={()=>redirect('/products/modifiergroups/create')}
                    >
                        <Typography>Agregar</Typography>
                    </Button>
                </Grid>
            </Grid>
            

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <br/>
                    <ModifierGroupsDataTable
                        modiferGoups={modifierGroups}
                        onDelete={handleDeleteModifierGroup}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
        </Container>
    )
}